import { ItemTypeVoData } from "../..";
import { CheckUtils } from "../../index";
var ItemsTypesConverter = /** @class */ (function () {
    function ItemsTypesConverter() {
    }
    ItemsTypesConverter.convertToItemsTypeVoData = function (itemsTypeApiData) {
        var itemsTypeVoData = [];
        if (!CheckUtils.isEmpty(itemsTypeApiData)) {
            for (var _i = 0, itemsTypeApiData_1 = itemsTypeApiData; _i < itemsTypeApiData_1.length; _i++) {
                var itemType = itemsTypeApiData_1[_i];
                var itemTypeVoData = new ItemTypeVoData(itemType.name);
                itemTypeVoData.iconClassName = itemType.iconClassName;
                itemTypeVoData.iconColor = itemType.iconColor;
                itemTypeVoData.label = itemType.label;
                itemTypeVoData.file = itemType.file;
                itemsTypeVoData.push(itemTypeVoData);
            }
        }
        return itemsTypeVoData;
    };
    return ItemsTypesConverter;
}());
export { ItemsTypesConverter };
//# sourceMappingURL=items-types-converter.js.map


//////////////////
// WEBPACK FOOTER
// ../od-ts/dist/utils/converter/items-types-converter.js
// module id = 969
// module chunks = 14